import * as React from 'react';
import { CardCountIndicator } from '../CardCountIndicator/CardCountIndicator';
import { ISubCardsCountIndicatorProps } from './types';
import { getMessages } from '../../../../../../store/constants';

export function SubCardsCountIndicator({
    active,
    subCardsCount,
    onClick
}: ISubCardsCountIndicatorProps) {
    return (
        <CardCountIndicator
            active={active}
            icon={'subcard'}
            tooltip={getMessages().getText('kanban.subcards_tooltip', null, subCardsCount)}
            onClick={onClick}
        >
            {subCardsCount}
        </CardCountIndicator>
    );
}
